import { SCENARIO_ORDER } from './scenarioMeta';

/**
 * Metrics available in the scenario comparison chart. `field` is the calcResult
 * row (one value per output month); `format` drives axis / tooltip formatting.
 */
export const SCENARIO_METRICS = [
  { key: 'endBal', label: 'Twelve exposure', field: 'endBal', format: 'money' },
  { key: 'runrate', label: 'Runrate', field: 'runrate', format: 'money' },
  { key: 'runoff', label: 'Runoff', field: 'runoff', format: 'money' },
  {
    key: 'runoffCohortWindow',
    label: 'Runoff (cohort window)',
    field: 'runoffCohortWindow',
    format: 'money',
  },
  {
    key: 'runoffExposurePct',
    label: 'Runoff exposure',
    field: 'runoffExposurePct',
    format: 'percent',
  },
  {
    key: 'runrateExposurePct',
    label: 'Runrate exposure',
    field: 'runrateExposurePct',
    format: 'percent',
  },
];

function toNumericCell(value) {
  if (value == null || !Number.isFinite(Number(value))) {
    return null;
  }
  return Number(value);
}

/**
 * Build recharts-ready rows comparing a single metric across scenarios, aligned
 * by output-month index. Scenarios with different horizons are padded with null
 * (rendered as gaps / connected lines).
 *
 * @param {{base, bull, bear}} scenarioMap calcResult per scenario (null when off)
 * @param {string} field calcResult row key to plot
 * @returns {{ data: Array, activeKeys: string[] }}
 */
export function buildScenarioComparisonData(scenarioMap, field) {
  const map = scenarioMap || {};
  const activeKeys = SCENARIO_ORDER.filter((key) => map[key]);

  let labelCols = [];
  let maxLen = 0;
  activeKeys.forEach((key) => {
    const cols = Array.isArray(map[key].cols) ? map[key].cols : [];
    if (cols.length > maxLen) {
      maxLen = cols.length;
      labelCols = cols;
    }
    const arr = Array.isArray(map[key][field]) ? map[key][field] : [];
    if (arr.length > maxLen) {
      maxLen = arr.length;
    }
  });

  const data = [];
  for (let i = 0; i < maxLen; i += 1) {
    const row = { month: labelCols[i] ?? `M${i}` };
    activeKeys.forEach((key) => {
      const arr = map[key][field];
      row[key] = Array.isArray(arr) ? toNumericCell(arr[i]) : null;
    });
    data.push(row);
  }

  return { data, activeKeys };
}
